import { IElementType } from "@faro-lotv/ielement-types";
import { clearStore } from "@faro-lotv/project-source";
import { createSlice } from "@reduxjs/toolkit";
import { fetchProjectIElements } from "@store/i-elements/i-elements-slice-thunk";

/**
 * SdbIElementsState is an extra store state that expands the IElementsState.
 */

const initialState = Object.freeze({
  markupsIElementsFetchingStatus: "uninitialized",
  markupsIElementsRequestId: undefined
});
const sdbIElementsSlice = createSlice({
  name: "sdbIElements",
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder.addCase(fetchProjectIElements.pending, (state, action) => {
      if (action.meta.arg.types?.includes(IElementType.markup)) {
        state.markupsIElementsFetchingStatus = "pending";
        state.markupsIElementsRequestId = action.meta.requestId;
      }
    }).addCase(fetchProjectIElements.fulfilled, (state, action) => {
      if (state.markupsIElementsRequestId === action.meta.requestId) {
        state.markupsIElementsFetchingStatus = "succeeded";
      }
    }).addCase(fetchProjectIElements.rejected, (state, action) => {
      if (state.markupsIElementsRequestId === action.meta.requestId) {
        // An aborted request is not an error, so the markups can be fetched again
        state.markupsIElementsFetchingStatus = action.meta.aborted ? "uninitialized" : "rejected";
      }
    })
    // Use the clearStore action from the lotv package so that upon calling clearStore it wil
    // clear both the IElementsState and the SdbIElementsState
    .addCase(clearStore, () => initialState);
  }
});
export const sdbIElementsReducer = sdbIElementsSlice.reducer;